<template>
    <span v-if="unreadCount" class="nav-unread"></span>
</template>
<script>
export default {
    computed: {
        unreadCount() {
            return this.$store.getters['notifications/unreadCount'];
        }
    }
};
</script>
